<template>
  <div>
    <p>{{subtitle}}</p>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import actionBaseMixin from '../mixins/action-base-mixin';
  import {ObjectModelDefaultActionType} from "~/enums/objectModelDefaultActionType";

  export default Vue.extend({
    mixins: [actionBaseMixin],
    computed: {
      subtitle(): string {
        switch (this.objectModelAction.default_action_type) {
        case ObjectModelDefaultActionType.Create:
          return 'Create a New Record';
        case ObjectModelDefaultActionType.Edit:
          return 'Edit an Existing Record';
        case ObjectModelDefaultActionType.Delete:
          return 'Delete an Existing Record';
        }
      },
    },
  });
</script>